<mat-slide-toggle [formControl]="formControl"
                  [attr.data-element]="'qa-element-slide-toggle'"
                  [attr.data-qa]="qaAttr"
                  (change)="onSlideToggleChange($event)">{{ label }}
</mat-slide-toggle>